import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SoundManager} from "../sound/SoundManager";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {TombOfAkhenaten} from "../TombOfAkhenaten";

export class NormalWin implements GameRoundPresentation {

    stagger?: number;
    abortStagger?: number;

    private _hasWin: boolean;
    private _tl: TimelineLite;

    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data: TombOfAkhenatenParsedGameData): void {
        this._hasWin = data.singleWin > 0 && !data.isBigWin;

        // #437
        TombOfAkhenatenGameConfig.instance.WIN_BELOW_STAKE = (TombOfAkhenaten.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
    }

    public getAnimation(data: TombOfAkhenatenParsedGameData): Timeline | null {
        if (!this._hasWin) {
            return null;
        }

        this._tl = new TimelineLite();

        // #437
        if (!TombOfAkhenatenGameConfig.instance.WIN_BELOW_STAKE) {
            this._tl.add(
                () => {
                    this.playWinSound(data.currentWinRatioConfig?.type, data.mode);
                }
            );
        }

        //#116 show count up after symbol win animation
        this._tl.add(this.addWinCountUpToTimeline(data), 0.25);
        return this._tl;
    }

    public abort(isActive: boolean, data: TombOfAkhenatenParsedGameData): Timeline | null {
        if (isActive && this._tl) {
            this._tl.progress(1);
        }
        return null;//this.getAnimation(data);
    }

    protected addWinCountUpToTimeline(data: TombOfAkhenatenParsedGameData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        const duration: number = data.currentWinRatioConfig!.duration;

        let totalWinWaysWon: number = 0,
            winAmount: number = 0;

        for (let i: number = 0; i < data.betWins.length; i++) {
            const betWayWinData: IBetWayWinData = <IBetWayWinData>data.betWins[i];
            totalWinWaysWon = totalWinWaysWon + betWayWinData.numberOfCombinations;
            winAmount = winAmount + betWayWinData.amount;
        }

        tl.add(TombOfAkhenatenGameModuleConfig.toaWinCountUp.getCountUpAnimation(totalWinWaysWon, 0, winAmount, duration, data.payoutMultiplier, data.currentWinRatioConfig, data));

        return tl;
    }

    private playWinSound(winRatioType: any, gameMode: string): void {
        // #316
        /*let isBonus = TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(gameMode) > -1;
        if (!isBonus && winRatioType && (winRatioType === "large" || winRatioType === "medium")) {
            SoundManager.playMediumAndLargeWinSound();
        }*/
        SoundManager.playWinSound(winRatioType);
    }
}